import { Link, usePage } from "@inertiajs/react"
import {
  LayoutGrid,
  MessageCirclePlus,
  MessagesSquare,
  Sparkles,
  Rss,
} from "lucide-react"

import { NavFooter } from "@/components/nav-footer"
import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { dashboardPath } from "@/routes"
import type { NavItem, SharedData } from "@/types"
import { isWaitlisted } from "@/lib/user-utils"

import AppLogo from "./app-logo"

const mainNavItems: NavItem[] = [
  {
    title: "Dashboard",
    href: dashboardPath(),
    icon: LayoutGrid,
  },
  {
    title: "New Conversation",
    href: "/conversations/new",
    icon: MessageCirclePlus,
  },
  {
    title: "Conversations",
    href: "/conversations",
    icon: MessagesSquare,
  },
  {
    title: "Flashcards",
    href: "/flashcards",
    icon: Sparkles,
  },
  {
    title: "Self Study",
    href: "/self-study/new",
    icon: LayoutGrid, // Using LayoutGrid temporarily, user can change icon. Actually maybe BookOpen or similar if available, else standard.
  },
]

// TODO: Add Social media links here
const footerNavItems: NavItem[] = [
  // {
  //   title: "Repository",
  //   href: "https://github.com/inertia-rails/react-starter-kit",
  //   icon: Folder,
  // },
  {
    title: "Blog",
    href: "https://blog.thaicopilot.com/",
    icon: Rss,
  },
]

export function AppSidebar() {
  const { auth, feature_flags } = usePage<SharedData>().props
  const waitlisted = isWaitlisted(auth.user)

  const visibleNavItems = mainNavItems.filter((item) => {
    if (item.href === "/self-study/new") return feature_flags?.self_study
    return true
  })

  return (
    <Sidebar collapsible="icon" variant="inset">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <Link href={dashboardPath()} prefetch>
                <AppLogo />
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>

      <SidebarContent>
        {!waitlisted && <NavMain items={visibleNavItems} />}
      </SidebarContent>

      <SidebarFooter>
        {!waitlisted && (
          <NavFooter items={footerNavItems} className="mt-auto" />
        )}
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  )
}
